export default __webpack_public_path__ + "static/media/Validator.0a8d53ea.svg";